// extracted by mini-css-extract-plugin
export default {"Accents":"Accents_Accents__ZoBLu","InnerContainer":"Accents_InnerContainer__ZA256"};